import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 30.5px 24px 24px;
  width: 320px;
  background: ${colors.white};
  border-radius: 4px;

  @media ${device.mobileMax} {
    width: 100%;
  }
`

export const Divider = styled.div`
  margin-bottom: 24px;
  height: 1px;
  background-color: ${colors.greyStroke};
`

export const Title = styled.h3`
  margin: 0 0 21.5px 0;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const TrackNameRow = styled.div`
  display: flex;
  align-items: center;
  max-width: 150px;
`

export const SpotifyIcon = styled.img`
  margin-right: 16px;
  width: 24px;
  height: 24px;
`

export const RowText = styled.span<{ bold?: boolean }>`
  font-size: 14px;
  line-height: 21px;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  color: ${colors.mainText};
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media ${device.mobileMax} {
    display: none;
  }
`

export const ContinueButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 9.5px 40px;
  width: 100%;
  background-color: ${({ disabled }) =>
    disabled ? colors.greyTextBlackBg : colors.green};
  font-size: 14px;
  color: ${colors.white};
  border-radius: 100px;
  cursor: pointer;
  white-space: nowrap;
  height: 40px;
`

export const ContinueButtonPaypal = styled.button<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 9.5px 40px;
  width: 100%;
  background-color: ${({ disabled }) =>
    disabled ? colors.greyTextBlackBg : colors.green};
  font-size: 14px;
  color: ${colors.white};
  border-radius: 100px;
  cursor: pointer;
  pointer-events: none;
  position: absolute;
  white-space: nowrap;
  height: 40px;
`

export const PromoCodeButton = styled.div`
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 17.5px 0 25.5px;
  width: fit-content;
  font-size: 14px;
  color: ${colors.mainText};
  border-bottom: 1px dashed ${colors.mainText};
  background-color: transparent;
  cursor: pointer;
  white-space: nowrap;
`
export const PaypalButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
`

export const CampaignsTracksPromocode = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 16px;
`

export const CampaignsTracksPromocodeDiscount = styled.div`
  color: ${colors.green};
  font-weight: 400;
`

export const CampaignsTracksPromocodeExist = styled.div`
  color: ${colors.greyTextBlackBg};
  text-decoration-line: line-through;
  text-decoration-color: ${colors.messegesRed};
`

export const AlertProtectionWrapper = styled.div`
  position: absolute;
  bottom: -16px;
  left: 0;
  transform: translateY(100%);
  display: grid;
  grid-template-columns: 21px 1fr;
  gap: 17.5px;
  border-radius: 4px;
  width: 100%;
  font-size: 14px;
  color: ${colors.greyTextWhiteBg};
`

export const AlertProtectionWrapperText = styled.div`
  display: grid;
  line-height: 21px;
  > span:first-of-type {
    font-weight: 600;
  }
`

export const SecurePaymentBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;

  img {
    width: 16px;
  }
`

export const SecurePaymentText = styled.span`
  margin: -1px 0 0 10px;
  font-size: 10px;
  line-height: 150%;
  color: ${colors.greyTextWhiteBg};
`
